export default {
  NOT_STARTED: 'NOT_STARTED',
  STAGE_1_BIO_COMPLETED: 'STAGE_1_BIO_COMPLETED',
  STAGE_2_CONTACT_COMPLETED: 'STAGE_2_CONTACT_COMPLETED',
  STAGE_3_LIFESTAGE_COMPLETED: 'STAGE_3_LIFESTAGE_COMPLETED',
};
